import CompleteYourProfile from "../views/CompleteYourProfile";
import WhatsAppSupportButton from "../components/WhatsAppSupportButton";

function CompleteYourProfilePage() {
  return (
    <>
      <CompleteYourProfile />
      {/* Scoped to this page rather than mounted globally: the button is fixed
          bottom-right, where it sat on top of the pagination controls on every
          data table in the app. This page has no table, and it is where a
          part-way-through signup is most likely to need help. */}
      <WhatsAppSupportButton />
    </>
  );
}

export default CompleteYourProfilePage;
